import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { fetchTenantSwitchSettings } from '@/api/tenantApi';
import {
  FetchTenantSwitchSettingsResponse,
  SwitchTargetTenant,
} from '@/types/api/tenantApi';

type UseFetchTenantSwitchSettingsParams = {
  m_affiliate_id: number;
};

export const useFetchTenantSwitchSettings = ({
  m_affiliate_id,
}: UseFetchTenantSwitchSettingsParams) => {
  const [data, setData] = useState<FetchTenantSwitchSettingsResponse['data']>();
  const [tenantSwitchEnabled, setTenantSwitchEnabled] = useState(false);
  const [switchTargets, setSwitchTargets] = useState<SwitchTargetTenant[]>([]);
  const [error, setError] = useState<AxiosError>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!m_affiliate_id) return;

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const res = await fetchTenantSwitchSettings({ m_affiliate_id });
        const responseData = res.data;

        setData(responseData);
        setTenantSwitchEnabled(responseData.tenant_switch_enabled ?? false);
        setSwitchTargets(responseData.switch_targets ?? []);
      } catch (err) {
        setError(err as AxiosError);
        setTenantSwitchEnabled(false);
        setSwitchTargets([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [m_affiliate_id]);

  return {
    data,
    error,
    isLoading,
    tenantSwitchEnabled,
    switchTargets,
  };
};
